import VendaProdutoServicoList from './ProdutoServicoList';

export default VendaProdutoServicoList;
